import { RouteProp, useRoute } from '@react-navigation/native';
import { ImageViewer, theme } from 'aimo-ui';
import { BackButton } from 'components/map/MapButtons';
import ParkingSpaceSelector from 'components/park/longTermParking/ParkingSpaceSelector';
import Sheet from 'components/sheets/Sheet';
import useIsDesktop from 'hooks/useIsDesktop';
import useSafeContainerDimension from 'hooks/useSafeContainerDimension';
import React, { useMemo, useState } from 'react';
import { useWindowDimensions } from 'react-native';
import { SheetDetailsWrapper } from 'styles/ContainerStyles';
import { RootStackParamList } from 'types/navigation';
import { isWeb } from 'utils/deviceUtils';

const ParkingSpaceMapViewerScreen: React.FC = () => {
  const [heightRatio, setRatioScale] = useState<number>();
  const { params: { spotMap: spotMapUrl, pmcId, showOnlyMap } = {} } =
    useRoute<RouteProp<RootStackParamList, 'parkingSpaceMapViewer'>>();
  const isDesktop = useIsDesktop();
  const { notchPercentage } = useSafeContainerDimension();
  const { height } = useWindowDimensions();
  const [hideSheet, setHideSheet] = useState(false);

  const snappingPoints = useMemo(() => {
    if (!spotMapUrl) {
      return ['80%'];
    }
    const calculatedHeightPercentage = heightRatio
      ? 100 - heightRatio * (50 - notchPercentage)
      : 50;
    return [
      `${calculatedHeightPercentage < 25 ? 25 : calculatedHeightPercentage}%`,
    ];
  }, [heightRatio, spotMapUrl, notchPercentage]);

  const webSheetMaxHeight = useMemo(() => {
    if (isWeb && heightRatio && spotMapUrl) {
      const calculatedHeightPercentage = (100 - heightRatio * 50) / 100;
      return height * calculatedHeightPercentage;
    }
  }, [height, heightRatio, spotMapUrl]);

  return (
    <>
      {spotMapUrl && (
        <ImageViewer
          onRatioScaleCalculated={setRatioScale}
          imageUrl={spotMapUrl}
          isDesktop={isDesktop}
          onDoubleTap={() => isWeb && window.open(spotMapUrl, '_blank')}
          fullScreen={!!showOnlyMap}
          onPressHold={setHideSheet}
        />
      )}
      <BackButton testID="parking-space-back-button" />
      {!showOnlyMap && !(hideSheet && isDesktop) && (
        <Sheet
          bgColor={theme.colors.white}
          showBackDropIndex={1}
          sheetMaxHeight={webSheetMaxHeight}
          snappingPoints={snappingPoints}>
          <SheetDetailsWrapper>
            <ParkingSpaceSelector pmcId={pmcId} />
          </SheetDetailsWrapper>
        </Sheet>
      )}
    </>
  );
};

export default ParkingSpaceMapViewerScreen;
